<div class="content page-gateway">
  <div class="container-fluid about">
    <div class="page-title flex">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{'Advanced Settings' | translate}}
      </h1>
      <button pButton type="button" label="{{'Update to New Version' | translate}}" class="ui-button-danger"
        [disabled]="!selectedNode || selectedNode.length === 0" (click)="updateGatewayCheck();"></button>
    </div>
    <div class="page-content">
      <p-table class="deviceTable pageAllOptions" [columns]="advanced_setting_cols" [value]="advanced_setting_list"
        [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true" (selectionChange)="onSelectionChange($event)"
        [(selection)]="selectedNode" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)" dataKey="Id">
        <ng-template pTemplate="header" let-columns let-i="index">
          <tr>
            <th style="width: 60px"></th>
            <th style="width: 60px">
              <p-tableHeaderCheckbox *ngIf="checkHeaderCheckbox"></p-tableHeaderCheckbox>
            </th>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.field === 'automatic'" [hidden]="col.field === 'company' ? !isMsp : null"
                [ngStyle]="{'width.px': col.width }" [ngClass]="col.class">
                {{col.header | translate}}
                <i class="fa fa-info-circle" pTooltip="{{'Allow this Gateway to be updated automatically' | translate}}"
                  tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
              </th>
              <th *ngIf="col.field !== 'automatic'" [hidden]="col.field === 'company' ? !isMsp : null"
                [pSortableColumn]="col.field" [ngStyle]="{'width.px': col.width }" [ngClass]="col.class">
                {{col.header | translate}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData" [class.offline]="rowData.status === 1" [class.notUpdateAvalible]="!rowData.updateAvalible" [pSelectableRowIndex]="rowIndex">
            <td style="width: 60px;text-align: center">
              <div class="flex crud">
                <button type="button" pButton icon="fa fa-pencil-square-o" class="editBtn"
                  (click)="showEditDialog(rowData)" [disabled]="rowData.status === 1"></button>
                <button type="button" pButton icon="fa fa-trash" class="delete"
                  (click)="showConfirmDeleteDialog(rowData)" [disabled]="rowData.gatewayDisabled"></button>
              </div>
            </td>
            <td style="width: 60px">
              <p-tableCheckbox [value]="rowData" *ngIf="rowData.versionStatus === 1 && rowData.status === 0 && !rowData.gatewayDisabled"
                [index]="rowIndex"></p-tableCheckbox>
            </td>
            <td style="width: 200px" class="col-nowrap">
              {{rowData.name}}
            </td>
            <td style="width: 200px" class="col-nowrap" [hidden]="!isMsp"> {{rowData.company}}</td>
            <td style="width: 100px">{{GateWayStatus[rowData.status] | translate}}</td>
            <td style="width: 150px" class="col-nowrap">{{rowData.ipAddress}}</td>
            <td style="width: 150px">{{rowData.connectDevice}}</td>
            <td style="width: 150px" class="col-nowrap card-version" [ngSwitch]="rowData.versionStatus">
              <div class="flex">
                <a routerLink="/gateway-setting/gateway-version/{{rowData.hashId}}">{{rowData.version}}</a>
                <div class="icon">
                  <i *ngSwitchCase="0" class="fa fa-check-circle normal"></i>
                  <i *ngSwitchCase="1" class="fa fa-info-circle" pTooltip="{{'New Version Available' | translate}}"
                    tooltipPosition="bottom" tooltipStyleClass="available"></i>
                  <span *ngSwitchCase="2" class="fa-stack custom-stack" pTooltip="{{'New Version Updating' | translate}}"
                    tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                    <i class="fa fa-circle"></i>
                    <i class="fa fa-refresh fa-stack-1x fa-inverse fa-spin"></i>
                  </span>
                </div>
              </div>
            </td>
            <td style="width: 150px" class="col-nowrap"><p-toggleswitch [ngModel]="rowData.automatic"
                [disabled]="rowData.status === 1" (onChange)="checkAutomaticStatus(rowData);"></p-toggleswitch></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="advanced_setting_cols.length">
              <div translate class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>

</div>

<!-- Add/Edit -->
<p-dialog header="{{dialogInput.UpdateType | translate}}" [(visible)]="displayEditGatewayNameDailog" [modal]="true"
  [style]="{'width': '450px', 'min-width': '200px'}" [baseZIndex]="10000" class="gatewayDialog">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Gateway Name</label>
      <input type="text" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.name"
        (ngModelChange)="onNameChange($event)">
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="displayEditGatewayNameDailog=false;" label="{{'Cancel' | translate}}"
      class="p-button-secondary"></button>
    <button type="button" pButton (click)="EditGatewayNameSave();" label="{{'Save' | translate}}"
      class="ui-button-danger" [disabled]="gatewayname_invalid || gatewayName === dialogInput.name"></button>
  </ng-template>
</p-dialog>

<!-- Confrim -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [baseZIndex]="11000" [modal]="true"
  [style]="{'width': '450px'}" class="ConfirmDialog setup">
  <div cla="page-content-body">
    <p translate>Are you sure you want to delete this Gateway?</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}"
      class="p-button-secondary"></button>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"
      (click)="deleteGateway()"></button>
  </ng-template>
</p-dialog>

<!-- Warning -->
<p-dialog header="{{'Warning' | translate}}" [(visible)]="displayWarningDialog" [baseZIndex]="11000" [modal]="true"
  [style]="{'width': '450px'}" class="ConfirmDialog setup">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please delete all devices added by this gateway and the discovery job associated with this gateway
        before deleting it.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"
      (click)="displayWarningDialog=false"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'Alert' | translate}}" [(visible)]="twoFactorAuthenticationAlertDialog" [baseZIndex]="11000" [modal]="true"
  [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please enable 2-Factor Authentication to continue the update process.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="twoFactorAuthenticationAlertDialog=false;"
      class="ui-button-danger"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'New Version Update' | translate}}" [(visible)]="gatewayUpdateDialog" [baseZIndex]="11000"
  [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5 translate>The update process will take few minutes.</h5>
      <p translate>Please do not manually restart the Gateway software to avoid any update failures.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Start' | translate}}" class="ui-button-danger"
      (click)="startUpdate()"></button>
    <button type="button" pButton (click)="gatewayUpdateDialog=false" label="{{'Cancel' | translate}}"
      class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'New Version Update' | translate}}" [(visible)]="gatewayUpdateResultDialog" [baseZIndex]="11000"
  [modal]="true" [style]="{'width': '450px'}" class="gatewayDialog ConfirmDialog setup" [closable]="false">
  <div class="dialog-content" *ngIf="updateResult === 0">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 translate>Gateway update process is complete.</h5>
    </div>
  </div>
  <div class="dialog-content" *ngIf="updateResult === 1">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>An error occurred during the update process.</h5>
      <p translate>Please try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'OK' | translate}}" class="ui-button-danger"
      (click)="gatewayUpdateResultDialog=false"></button>
  </ng-template>
</p-dialog>
<app-dialog (connectEvt)="confrimUpgradeGatewayCode($event);"></app-dialog>